import { NgClass } from '@angular/common';
import { Component, computed, inject, input, ViewChild } from '@angular/core';
import { PortalUserMenuComponent } from '@reflact/portal-ecosystem';
import { LanguageService } from '@shared-angular/services/language.service';
import { LoginService } from '@shared-angular/services/login.service';
import { readLoginPortalUrl } from '@shared-angular/services/usertoken.service';
import type { MenuItem } from 'primeng/api';
import { ButtonModule } from "primeng/button";
import { TooltipModule } from 'primeng/tooltip';
import { MandantContextService } from '../../../services/mandant-context.service';
import { GlobalSearchComponent } from '../../global-search/global-search.component';

@Component({
  selector: 'app-page-header',
  imports: [NgClass, GlobalSearchComponent, TooltipModule, ButtonModule, PortalUserMenuComponent],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  public readonly projectOverview = input(false);
  @ViewChild('globalSearch') public globalSearch!: GlobalSearchComponent;
  public loginService: LoginService = inject(LoginService);
  public langService: LanguageService = inject(LanguageService);
  public mandantContext = inject(MandantContextService);
  public readonly portalUrl = readLoginPortalUrl() ?? '';
  // #558: ends all sessions of the user on every device; shown before "Abmelden" in the user menu.
  public readonly userMenuItems: MenuItem[] = [{
    label: $localize`:@@logout-everywhere:Überall abmelden`,
    icon: 'ri-logout-circle-r-line',
    command: () => void this.loginService.logoutEverywhere()
  }];
  public readonly allMandantsLabel = $localize`:@@all-organizations:Alle Mandanten`;
  public readonly additionalContexts = computed<MenuItem[]>(() => this.mandantContext.mandants().length > 1
    ? [{ label: this.allMandantsLabel, icon: 'ri-stack-line', command: () => this.mandantContext.select(undefined) }]
    : []);

  public openSearch(): void {
    this.globalSearch.open();
  }
}
